<template>
  <div>
    <basehead />
    <div class="row">
      <h2 class="col-md-9 m-auto">Experiments</h2>
    </div>
    <div class="container">
      <ExperienceTypeChooser
        class="card-group"
        institution_filter="all"
      ></ExperienceTypeChooser>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ExperienceTypeChooser from "@/components/ExperienceTypeChooser.vue";
import basehead from "@/components/basehead.vue";

export default {
  name: "home",
  components: {
    basehead,
    ExperienceTypeChooser
  },
  data() {
    return {
      locales: [
        { id: "en", name: "English", icon: "../assets/english.png" },
        { id: "fr", name: "Français", icon: "../assets/france.png" }
      ],
      currentLocale: "en"
    };
  }
};
</script>
